/***
* Add by jfzhu
* created:20190805
* 注:商家联盟拓客首页
*/
<template>
  <div>
    <div class="store-detail">
      <img class="pic-img" :src="imageUrl + storeInfo.picInfo">
      <div class="title-div">
        <span>到店后请联系客服</span>
        <span>出示二维码享受优惠</span>
      </div>
      <div class="store-info">
        <div class="name-info">
          <span class="name">{{ storeInfo.name }}</span>
          <div class="btn-div">
            <div class="phone-btn" @click="cell">拨打电话</div>
            <div class="map-btn" @click="goMap">查看地图</div>
          </div>
        </div>
        <div class="address-info">
          <img src="../../resource/img/地址@2x.png"/>
          <span class="address">{{ storeInfo.address }}</span>
        </div>
      </div>
      <div class="goods-info">
        <span class="title">商品信息</span>
        <template v-for="item in storeInfo.unionProductEntityList">
          <div class="item">
            <span>商品名称</span>
            <span class="text">{{ item.name }}</span>
          </div>
          <div class="item">
            <span>使用说明</span>
            <span class="text">{{ item.intro }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'

export default {
  name: 'store-detail',
  data () {
    return {
      storeInfo: null,
      // imageUrl: sessionStorage.url,
      imageUrl: 'https://files.mbspt.com'
    }
  },
  created () {
    if (!this.$util.isArrOrNull(this.$route.query.storeInfo)) {
      this.storeInfo = JSON.parse(this.$route.query.storeInfo)
    }
  },
  methods: {
    cell () {
      window.location.href = 'tel:' + this.storeInfo.phone
    },
    goMap () {
      wx.openLocation({
        type: 'gcj02',
        latitude: Number(this.storeInfo.lat), // 纬度，浮点数，范围为90 ~ -90
        longitude: Number(this.storeInfo.lng), // 经度，浮点数，范围为180 ~ -180。
        name: this.storeInfo.name, // 位置名
        address: this.storeInfo.address, // 地址详情说明
        scale: 14, // 地图缩放级别,整型值,范围从1~28。默认为最大
      })
    },
  }
}
</script>

<style scoped>
.store-detail {
  padding: 50px 0vw 0 0vw;
  font-size: 15px;
}

.store-detail .pic-img {
  width: 100%;
  height: 200px;
}

.store-detail .title-div {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 15px;
  background-color: #fff;
  height: 45px;
  line-height: 45px;
}

.store-detail .title-div > span {
  color: #1DA437;
  margin-right: 20px;
}

.store-detail .store-info {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  margin-top: 10px;
  background-color: #fff;
}

.store-detail .store-info .name-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  line-height: 50px;
}

.store-detail .store-info .name-info .name {
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.store-detail .store-info .name-info .btn-div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.store-detail .store-info .name-info .phone-btn {
  background-color: #1DA437;
  color: #fff;
  height: 35px;
  line-height: 35px;
  padding: 0 15px;
  border-radius: 5px;
  margin-right: 15px;
}

.store-detail .store-info .name-info .map-btn {
  background-color: #D0302C;;
  color: #fff;
  height: 35px;
  line-height: 35px;
  padding: 0 15px;
  border-radius: 5px;
}

.store-detail .store-info .address-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  line-height: 40px;
}

.store-detail .store-info .address-info > img {
  width: 18px;
  height: 23px;
  margin-right: 5px;
}

.store-detail .store-info .address-info > span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.store-detail .goods-info {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 15px;
  margin-top: 10px;
}

.store-detail .goods-info .title {
  font-weight: 600;
}

.store-detail .goods-info .item {
  display: flex;
  flex-direction: column;
  height: 40px;
  padding: 10px 0;
}

.store-detail .goods-info .item .text {
  margin-top: 5px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/active/MerUnionStoreDetail.vue